import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import '../../../../styles/DashboardProspectPopup.css';
import {
    updateApplicationStatus,
    markTourCompleted,
    toggleProspectExclusion
} from '../../../../api/Prospect';
import Button from '../../../common/form/Button';
import { useState } from 'react';
import { TourStatuses } from '../../../../utilities/Enums';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import { userIsCompanyDashboardUser, userIsPropertyDashboardUser, userIsSystemAdmin, userIsSystemDashboardUser } from '../../../../utilities/identity';
import LoadingOverlay from '../../../common/LoadingOverlay';
import moment from 'moment-timezone';

enum RecentActivityType {
    Tours,
    Prospects
}

interface PopupProps {
    tourInfo: any | undefined;
    tourId: string | null;
    setSelectedTab: (tab: RecentActivityType) => void;
    setSelectedProspectId: (prospectId: string | null) => void;
    setSelectedTourId: (tourId: string | null) => void;
}


export const DashboardProspectTourPopup = ({
    tourInfo,
    tourId,
    setSelectedTab,
    setSelectedProspectId,
    setSelectedTourId
}: PopupProps) => {

    let fontSizeStyle = {
        fontSize: '15px'
    };
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const [tourChangeLoading, setTourChangeLoading] = useState(false);

    const viewRole = userIsCompanyDashboardUser() ||
        userIsPropertyDashboardUser() ||
        userIsSystemDashboardUser();

    const handleIncludeOrExclude = async (tourId: any) => {

        setTourChangeLoading(true);
        if (tourInfo['tourInformation']['tourGuid'] === undefined) {
            setErrorMessage('Prospect has no associated ID.');
            setTourChangeLoading(false);
            return;
        }

        let excludeResult = await toggleProspectExclusion(tourInfo['tourInformation']['tourGuid']);
        if (excludeResult.success) {
            tourInfo['prospect']['excludeFromStatistics'] =
                !tourInfo['prospect']['excludeFromStatistics']
            setErrorMessage(undefined);
        } else if (excludeResult.error) {
            setErrorMessage(excludeResult.error);
        }

        setTourChangeLoading(false);
    };


    const closePopup = () => {
        setSelectedTourId(null);
    };

    return (
        <Modal isOpen={tourId !== null} toggle={closePopup} className="prospect-popup">
            <LoadingOverlay show={tourChangeLoading} inBootstrapColumn={false} />
            <ModalBody>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <h5 style={{ color: '#888888', fontSize: '20px' }}>Activity Information:</h5>
                    <div style={{ cursor: 'pointer' }} onClick={()=>{
                        closePopup()
                    }}>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.92422 0.326953C1.48359 -0.108984 0.771094 -0.108984 0.330469 0.326953C-0.110156 0.762891 -0.105469 1.48008 0.330469 1.9207L8.90859 10.4988L0.330469 19.077C-0.110156 19.5176 -0.110156 20.2301 0.330469 20.666C0.771094 21.102 1.48359 21.1066 1.91953 20.666L10.4977 12.0879L19.0805 20.6707C19.5211 21.1113 20.2336 21.1113 20.6695 20.6707C21.1055 20.2301 21.1102 19.5176 20.6695 19.0816L12.0914 10.5035L20.6742 1.9207C21.1148 1.48008 21.1148 0.767578 20.6742 0.331641C20.2336 -0.104297 19.5211 -0.108984 19.0852 0.331641L10.507 8.90977L1.92422 0.326953Z" fill="#888888"/>
                        </svg>
                    </div>
                </div>
                <p className='exterior-head-text'>Prospect</p>
                <div onClick={()=>{
                        setSelectedProspectId(tourInfo.prospect.prospectid)
                        setSelectedTourId(null)
                        setSelectedTab(RecentActivityType.Prospects)
                  }}>
                    <h3 className='prospect-name'>
                        {tourInfo.prospect.firstName} {tourInfo.prospect.lastName}
                    </h3>
                </div>
                <p className='exterior-head-text'>Activity</p> 
                <div className="space-y-4">
                    <div key={tourInfo.tourId} style={{ background: '#f6f6f6' }} className="border rounded shadow p-2 mb-2">
                        <p className='container-head-text' >{tourInfo.propertyName}</p>
                        <div className="mt-2">
                            <p>{tourInfo['tourInformation']['tourStatus']}</p>
                            <div style={{ marginLeft: '12px' }}>
                            {tourInfo['tourInformation']['companyName']!=null &&
                                <p>
                                    <strong className="container-lable-key">Company Name:</strong> {tourInfo['tourInformation']['companyName']}
                                </p>
                            }
                            {tourInfo['propertyName']!=null &&
                                <p>
                                    <strong className="container-lable-key">Property Name:</strong> {tourInfo['propertyName']}
                                </p>
                            }
                            {tourInfo['prospect']['partnerName']!=null &&
                                <p>
                                    <strong className="container-lable-key">Partner:</strong> {tourInfo['prospect']['partnerName']}
                                </p>
                            }
                            {tourInfo['tourInformation']['tourCreationDate']!=null &&
                                <p>
                                    <strong className="container-lable-key">Tour Creation Date:</strong> {tourInfo['tourInformation']['tourCreationDate']}
                                </p>
                            }
                            {tourInfo['tourInformation']['tourStartDate']!=null &&
                                <p>
                                    <strong className="container-lable-key">Tour Date:</strong> {tourInfo['tourInformation']['tourStartDate']}
                                </p>
                            }
                            {tourInfo['tourInformation']['tourStartTime'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Tour Time:</strong> {tourInfo['tourInformation']['tourStartTime']}
                                </p>    
                            }
                            {tourInfo['tourInformation']['tourEndTime'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Tour End Time:</strong> {tourInfo['tourInformation']['tourEndTime']}
                                </p>    
                            }
                            {tourInfo['prospect']['tourTypeDisplay'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Type:</strong> {tourInfo['prospect']['tourTypeDisplay']}
                                </p>
                            }
                            {tourInfo['prospect']['partnerName'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Partner:</strong> {tourInfo['prospect']['partnerName']}
                                </p>
                            }
                            {tourInfo['prospect']['contactPreferenceDisplay'] !=null &&  <p>
                                <strong className="container-lable-key">Contact Preference:</strong> {tourInfo['prospect']['contactPreferenceDisplay']}
                            </p>}
                            <p>
                                <strong className="container-lable-key">Desired Move-In Date:</strong> {moment(tourInfo['prospect']['moveInDate']).format('MM/DD/YYYY')}
                            </p>
                                <p>
                                <strong className="container-lable-key">Pets:  </strong> {tourInfo['prospect']['pets'] ? 'Allowed' : 'No Pets'}
                            </p>
                            {tourInfo['prospect']['source'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Source:  </strong> {tourInfo['prospect']['source']}
                                </p>
                            }
                            {tourInfo['prospect']['desiredLeaseLength'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Desired Lease Length:</strong> {tourInfo['prospect']['desiredLeaseLength']}
                                </p>    
                            }
                            {tourInfo['tourInformation']['idCheckStatus'] !=null &&
                                <p>
                                    <strong className="container-lable-key">ID Check Status:</strong> {tourInfo['tourInformation']['idCheckStatus']}
                                    {  tourInfo['tourInformation']['idCheckStatus'] === "Failed" && 
                                            <div className="tooltip-container">
                                                <svg style={{ verticalAlign: 'middle', marginLeft: '6px' }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.07692 5.65385H6.5V9.46154H6.92308M12 6.5C12 7.95869 11.4205 9.35764 10.3891 10.3891C9.35764 11.4205 7.95869 12 6.5 12C5.04131 12 3.64236 11.4205 2.61091 10.3891C1.57946 9.35764 1 7.95869 1 6.5C1 5.04131 1.57946 3.64236 2.61091 2.61091C3.64236 1.57946 5.04131 1 6.5 1C7.95869 1 9.35764 1.57946 10.3891 2.61091C11.4205 3.64236 12 5.04131 12 6.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.92306 3.74974C6.92306 3.86194 6.87848 3.96956 6.79914 4.0489C6.7198 4.12824 6.61219 4.17281 6.49998 4.17281C6.38777 4.17281 6.28016 4.12824 6.20082 4.0489C6.12148 3.96956 6.0769 3.86194 6.0769 3.74974C6.0769 3.63753 6.12148 3.52992 6.20082 3.45058C6.28016 3.37123 6.38777 3.32666 6.49998 3.32666C6.61219 3.32666 6.7198 3.37123 6.79914 3.45058C6.87848 3.52992 6.92306 3.63753 6.92306 3.74974Z" fill="black" stroke="black" stroke-width="0.5"/>
                                                </svg>
                                                <span className="tooltip">{(tourInfo['tourInformation']['failedReason'] != null && tourInfo['tourInformation']['failedReason'] != "" ? tourInfo['tourInformation']['failedReason']: "Not Available")}</span>
                                            </div>
                                    }
                                </p>
                            }
                            {tourInfo['tourInformation']['creditCardStatus'] !=null &&
                                <p>
                                    <strong className="container-lable-key">Credit Card Status:</strong> {tourInfo['tourInformation']['creditCardStatus']}
                                </p>
                            }
                            <p>
                                <strong className="container-lable-key">Excluded From Statistics:</strong> {tourInfo['prospect']['excludeFromStatistics'] ? 'YES': 'NO'}
                            </p>
                            {(tourInfo['tourInformation']['keyStatus'] !=null && tourInfo['tourInformation']['keyStatus'] !== "") &&
                                <p>
                                    <strong className="container-lable-key">Key Card Status:</strong> {tourInfo['tourInformation']['keyStatus']}
                                </p>
                            }
                            {tourInfo['history'].length>0 && <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {tourInfo['history'].length > 0 ? (
                                        <div className="tour-history remove-border" style={fontSizeStyle}>
                                            <p className='container-heading'>Tour History:</p>
                                            {tourInfo['history'].map((h: any) => (
                                                <li key={h.timestamp}>
                                                    <span>{h.timestamp}</span>
                                                    <span>{h.location}</span>
                                                </li>
                                            ))}
                                        </div>
                                    ) : null}
                                </div>}
                        
                            <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }} className="space-x-4 mt-4">
                                {userIsSystemAdmin() && (
                                        <Button
                                                addlClassName="btn-primary"
                                                text={
                                                    tourInfo['prospect']['excludeFromStatistics']
                                                        ? 'Include in Statistics'
                                                        : 'Exclude from Statistics'
                                                }
                                                onClick={()=>{
                                                    handleIncludeOrExclude(tourInfo.tourId)
                                                }}
                                                disabled={viewRole}
                                            />
                                )}
                                <Button
                                    disabled={viewRole}
                                    addlClassName="btn-primary"
                                    text={
                                        tourInfo['tourInformation']['applicationSubmitted']
                                            ? 'Unmark Applied'
                                            : 'Mark Applied'
                                    }
                                    onClick={async () => {
                                        if (tourInfo['tourInformation']['tourGuid'] === undefined) {
                                            setErrorMessage('Prospect has no associated ID.');
                                            return;
                                        }
                                        setTourChangeLoading(true);
                                        const result = await updateApplicationStatus(
                                            tourInfo['tourInformation']['tourGuid'],
                                            !tourInfo['tourInformation']['applicationSubmitted']
                                        );
                                        if (result.success) {
                                            tourInfo['tourInformation']['applicationSubmitted'] = !tourInfo['tourInformation']['applicationSubmitted']
                                            closePopup();
                                        } else if (result.error) {
                                            setErrorMessage(result.error);
                                        }
                                        setTourChangeLoading(false);
                                    }}
                                />
                                {tourInfo['tourInformation']['tourStatus'] === TourStatuses.NoShow && (
                                    <Button
                                        disabled={viewRole}
                                        addlClassName="btn-primary"
                                        text="Mark Tour Completed"
                                        onClick={async () => {
                                            setTourChangeLoading(true);
                                            if (tourInfo['prospect']['guestCardGuid'] === undefined) {
                                                setErrorMessage('Prospect has no associated ID.');
                                                setTourChangeLoading(false);
                                                return;
                                            }

                                            let completeResult = await markTourCompleted(tourInfo['prospect']['guestCardGuid']);

                                            if (completeResult.success) {
                                                tourInfo['tourInformation']['tourStatus'] = TourStatuses.Complete;
                                                
                                                closePopup();
                                            } else if (completeResult.error) {
                                                setErrorMessage(completeResult.error);
                                            }
                                            setTourChangeLoading(false);
                                        }}
                                    />
                                )}
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p style={{ fontSize: '12px' }}>Last Updated by {tourInfo.prospect.lastUpdateBy} at {moment(tourInfo.prospect.lastUpdatedDate).format('MM/DD/YYYY [at] h:mmA')}</p>
                <FormValidationDisplay errorMessage={errorMessage} />
            </ModalBody>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/dashboardProspectTourPopup.tsx